import { Injectable, inject } from '@angular/core';
import { NavigationTarget } from '../navigation-target';
import { LANDING_RULES, LandingContext } from './landing-rule';

/** Where a user lands after a regular sign-in: the first rule returning a target wins. */
@Injectable({ providedIn: 'root' })
export class UserJourney {
  private readonly rules = inject(LANDING_RULES);

  async resolve(context: LandingContext): Promise<NavigationTarget> {
    for (const rule of this.rules) {
      const target = await rule.resolve(context);
      if (target) {
        return target;
      }
    }
    throw new Error('User Journey: no landing rule matched, the last rule must be a fallback.');
  }
}
